// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__fli2i","requiredAsterisk":"Info_requiredAsterisk__VFjbG"};